import styled from 'styled-components';
import ReactSelect, { Theme } from 'react-select';

const wine = '#800020';
const wineLight = '#A00030';
const white = '#FFFFFF';
const lightGray = '#D3D3D3';
const darkGray = '#333333';
const black = '#000000';

export type SelectOption<T = string> = {
  label: string;
  value: T;
};

export const Select = styled(ReactSelect).attrs(({ error }) => ({
  theme: (selectTheme: Theme) => ({
    ...selectTheme,
    colors: {
      ...selectTheme.colors,
      primary: wine,
      primary25: wineLight,
      danger: '#FF0000',
      neutral0: white,
      neutral5: '#F5F5F5',
      neutral10: '#E0E0E0',
      neutral20: lightGray,
      neutral30: '#B0B0B0',
      neutral40: '#A0A0A0',
      neutral50: '#808080',
      neutral60: '#696969',
      neutral70: '#575757',
      neutral80: '#404040',
      neutral90: '#262626',
    },
  }),
  styles: {
    control: (base: any, state: any) => ({
      ...base,
      minHeight: '3rem',
      padding: '0 20px',
      marginBottom: '10px',
      fontSize: '1rem',
      borderWidth: '1px',
      borderRadius: '4px',
      borderColor: error ? '#FF0000' : lightGray,
      boxShadow: 'unset',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: state.isDisabled ? '#f2f2f2' : white,
      '&:hover': {
        borderColor: wine,
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: 0,
      color: black,
      fontFamily: 'Arial, sans-serif',
    }),
    menu: (base: any) => ({
      ...base,
      padding: '15px 12px',
      borderWidth: '1px',
      borderRadius: '4px',
      borderColor: lightGray,
      backgroundColor: white,
      zIndex: 99999,
      fontFamily: 'Arial, sans-serif',
    }),
    menuList: (base: any) => ({
      ...base,
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridAutoRows: 'min-content',
      rowGap: '10px',
    }),
    option: (
      base: any,
      props: { isSelected: boolean; isFocused: boolean }
    ) => ({
      ...base,
      backgroundColor:
        props.isSelected || props.isFocused ? wineLight : 'transparent',
      borderRadius: '4px',
      color: props.isSelected || props.isFocused ? white : wine,
      fontWeight: props.isSelected || props.isFocused ? '700' : '400',
      transition: 'background-color 0.2s, color 0.2s',
      fontFamily: 'Arial, sans-serif',
      '&:hover': {
        backgroundColor: wineLight,
        color: white,
      },
    }),
    singleValue: (base: any) => ({
      ...base,
      color: black,
      fontFamily: 'Arial, sans-serif',
    }),
    placeholder: (base: any) => ({
      ...base,
      color: darkGray,
      fontFamily: 'Arial, sans-serif',
      opacity: 1,
      fontWeight: '400',
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      color: black,
      '&:hover': {
        color: wine,
      },
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      backgroundColor: lightGray,
    }),
    clearIndicator: (base: any) => ({
      ...base,
      color: lightGray,
      '&:hover': {
        color: wine,
      },
    }),
  },
}))``;
